import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private defaultConfig: MatSnackBarConfig = {
    duration: 4000,
    horizontalPosition: 'right',
    verticalPosition: 'top',
  };

  constructor(private snackBar: MatSnackBar) {}

  showSuccess(message: string, action?: string, duration?: number): void {
    this.show(message, action, duration, ['toast-success']);
  }

  showError(message: string, action?: string, duration?: number): void {
    this.show(message, action, duration || 6000, ['toast-error']);
  }

  showWarning(message: string, action?: string, duration?: number): void {
    this.show(message, action, duration, ['toast-warning']);
  }

  showInfo(message: string, action?: string, duration?: number): void {
    this.show(message, action, duration, ['toast-info']);
  }

  private show(message: string, action?: string, duration?: number, panelClass?: string[]): void {
    this.snackBar.open(message, action || 'Close', {
      ...this.defaultConfig,
      duration: duration || this.defaultConfig.duration,
      panelClass: panelClass || [],
    });
  }

  dismiss(): void {
    this.snackBar.dismiss();
  }
}
